import React, {useEffect, useState}  from 'react'
import {useLocation} from 'react-router-dom';
import { authEventBus, AUTH_EVENTS } from '../../utils/AuthEvents';
import {Link} from 'react-router-dom';
import {useCategories } from '../../components/hooks/hooks-e-commerce/useCategories';
import {useGroups} from '../../components/hooks/hooks-e-commerce/useGroups';
import {NavShopUp} from './ModuleStore';
import {NavShopDown} from './ModuleStore';

import useCart from '../../components/hooks/hooks-e-commerce/useCart';
import useAuth from '../../components/hooks/hooks-e-commerce/useAuth';
import { useLoginModal } from '../../contexts/LoginModalContext';
import Cart from '../../shop/components/images/iconstore/cartW50.png';
import User from '../../shop/components/images/iconstore/UtenteW50.png';
import Lenth from '../../shop/components/images/iconstore/lenteW50.png';
import CartHover from '../../shop/components/images/iconstore/cartOranW50.png';
import UserHover from '../../shop/components/images/iconstore/UtenteOranW50.png';
import LenthHover from '../../shop/components/images/iconstore/lenteOranW50.png';
import iconLogout from '../../shop/components/images/iconstore/iconLogoutW40.png'
import './navbarstore.scss'

function NavBarStore() {
    // React hooks
    let location = useLocation();
    // useState
    const [countCart, setCountCart] = useState(0)
    const [hasCheckedAuth, setHasCheckedAuth] = useState(false);
    const [hiddenNavbarStore, setHiddenNavbarStore] = useState(false);
    //const [hasCheckedAuth, setHasCheckedAuth] = useState(false);
    const [isIconHovered, setIsIconHovered] = useState({
        lenth: false,
        cart: false
    });

    const [isUserHovered, setIsUserHovered] = useState(false);

    const { 
            user, 
        isAuthenticated, 
        getCurrentUser,
        logout, 
        loading: authLoading,
        syncExternalAuth 
        } = useAuth();

     // Custom hooks
    const {categories, loading: error } = useCategories();
    const {groups} = useGroups();
    const {cart, subscribe} = useCart();

    const { openLoginModal } = useLoginModal();

    const menuUp = categories.slice(0, 4);
    const menuDown = categories.slice(4, 9);
    const elencoGruppi = groups.map(item => ({
        nome: item.nome,
        id_categoria: item.id_categoria_prodotto,
        collegamento: item.collegamento,
    }));

    const elencoGruppiUp = elencoGruppi.slice(0, 22)
    const elencoGruppiDown = elencoGruppi.slice(22, 50)
    
    const handleIsHovered = (value) => {
        if(value === 1) {
            setIsIconHovered({lenth: true});
        } else if(value === 2) {
            setIsIconHovered({cart: true});
        } 
    }

    const handleNoHovered = (value) => {
        if(value === 1) {
            setIsIconHovered({lenth: false})
        } else if(value === 2) {
            setIsIconHovered({cart: false});
        } 
    }

    // ✅ Aggiungi per sincronizzazione
    useEffect(() => {
        // Ascolta cambiamenti di autenticazione da altri componenti
        const unsubscribe = authEventBus.subscribe(
            AUTH_EVENTS.AUTH_CHANGED, 
            (data) => {
                //console.log('📢 Header riceve aggiornamento auth:', data);
                syncExternalAuth(data.user, data.isAuthenticated);
            }
        );

        // Ascolta eventi specifici
        const unsubscribeLogin = authEventBus.subscribe(
            AUTH_EVENTS.LOGIN,
            (userData) => {
                //console.log('📢 Header riceve login event');
                syncExternalAuth(userData, true);
            }
        );

        const unsubscribeLogout = authEventBus.subscribe(
            AUTH_EVENTS.LOGOUT,
            () => {
                //console.log('📢 Header riceve logout event');
                syncExternalAuth(null, false);
            }
        );

        const unsubscribeUpdate = authEventBus.subscribe(
            AUTH_EVENTS.USER_UPDATED,
            (userData) => {
                //console.log('📢 Header riceve user update');
                syncExternalAuth(userData, true);
            }
        );

        return () => {
            unsubscribe();
            unsubscribeLogin();
            unsubscribeLogout();
            unsubscribeUpdate();
        };
    }, [syncExternalAuth]);

     // ✅ Inizializza l'auth una volta sola al mount
    useEffect(() => {
        const checkAuth = async () => {
            if (!hasCheckedAuth) {
                //console.log('🔄 Header: Verifico autenticazione utente...');
                await getCurrentUser();
                setHasCheckedAuth(true);
            }
        };
        checkAuth();
    }, [getCurrentUser, hasCheckedAuth]); 

    // ✅ SOTTOSCRIVITI AGLI AGGIORNAMENTI
    useEffect(() => {
        // Subscribe agli aggiornamenti del carrello
        const unsubscribe = subscribe((updatedCart) => {
            //console.log('🛒 Header: Carrello aggiornato', updatedCart);
            setCountCart(updatedCart?.item_count || 0);
        });

        // Cleanup
        return unsubscribe;
    }, [subscribe]);

    useEffect(() => {
        if (cart && cart.item_count !== undefined) {
            setCountCart(cart.item_count);

        } else {
            setCountCart(0);
        }
    }, [cart]);

    useEffect(() => {
        const isCheckout = location.pathname.includes('checkout');
        if(isCheckout) {
            setHiddenNavbarStore(false); 
        } else {
            setHiddenNavbarStore(true);
        } 
    }, [location]); 
    
    // ✅ 5. Condizioni di loading - CORRETTE
    if ((authLoading && !hasCheckedAuth)) {
        return <div className="header-loading">Caricamento...</div>;
    }
    
    if (error) {
        return <div className="header-error">Errore: {error}</div>;
    }

    return (
        <>
        {hiddenNavbarStore && 
        <nav className='catalogue-navbar' >
            <div className="store-navbar">
                <div className="navbar__arti">
                    <Link to="/negozioonline/zonaartigianale">
                        <p><span>ZONA</span>
                        <span>ARTIGIANALE</span></p>
                    </Link> 
                </div>
                <div className="navbar-menu">
                    <div className='menu__bar'>
                        <NavShopUp menuUp={menuUp} catalogo={elencoGruppiUp}/> 
                    </div>
                    <div className='menu__bar'>
                        <NavShopDown menuDown = {menuDown} catalogo={elencoGruppiDown}/>
                    </div>
                </div>
                <div className="navbar__cmd">
                    {/* ✅ Pulsante login/registrati */}
                    <div 
                        className="cmd__link" 
                        onMouseEnter={() => setIsUserHovered(true)} 
                        onMouseLeave={() => setIsUserHovered(false)}  
                        onClick={() => openLoginModal('login')}
                    >
                        <img 
                            className={`hover-effects ${isUserHovered ? 'hovered' : ''}`} 
                            src={isUserHovered ? UserHover : User} 
                            alt="Accedi/Registrati" 
                        />
                    </div>
                    <Link to="/" className="cmd__link" onMouseEnter={() => handleIsHovered(1)} onMouseLeave={() => handleNoHovered(1)}>
                        <img className={`hover-effects ${isIconHovered.lenth ? 'hovered' : ''}`} src={isIconHovered.lenth ? LenthHover : Lenth} alt="icon for lenth of search" /> 
                    </Link>
                    <div className="cmd-cart">
                        <Link to="carrello" className="cmd__link" onMouseEnter={() => handleIsHovered(2)} onMouseLeave={() => handleNoHovered(2)}>
                            <img className={`hover-effects ${isIconHovered.cart ? 'hovered' : ''}`} src={isIconHovered.cart ? CartHover : Cart} alt="icon for cart" />
                        </Link>
                        <div className="cart__number">
                            <span>{countCart}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="store-navbar-info">
                
                <div className='store-navbar-info__user' >
                    <span>Benvenuto ! </span> {isAuthenticated && <p> { user.nome ||' Utente'} </p>}
                    {isAuthenticated && <img src={iconLogout} title='Disconnettiti' alt="incon of logout" onClick={logout}/>}   
                </div>
            </div>
        </nav>}
        </>
    )
}  
export default NavBarStore;
